import { useQuery } from "@tanstack/react-query";
import { resourcesService } from "app/services";

export function useCargos() {
  const cargos = useQuery({
    queryKey: ["cargos"],
    queryFn: resourcesService.getCargos,
  });

  return cargos;
}
